import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface TabConfig {
  id: string;
  label: string;
  icon: string;
  translationKey: string;
}

@Component({
  selector: 'app-btb-tabs',
  templateUrl: './btb-tabs.component.html',
  styleUrls: ['./btb-tabs.component.scss']
})
export class BtbTabsComponent {
  @Input() tabs: TabConfig[] = [];
  @Input() activeTab: string = '';
  @Output() tabChange = new EventEmitter<string>();

  onTabClick(tabId: string) {
    this.tabChange.emit(tabId);
  }
}
